var m = require('mithril');
var Model = require('../../libs/Model');
var modalForm = require('../../layout/components/modalForm');
var session = require('../../auth/models/session');
var rowActionDropdown = require('../../components/rowActionDropdown');

var documentDefinition = require('../../../../../models/documents/Document');

var documentMetadata = modalForm(Object.assign({}, documentDefinition, Model, {
  isMultipart: false,
  fields: {
    name: documentDefinition.fields.name,
    description: documentDefinition.fields.description
  }
}));

function normalizeDocumentRecord(documentRecord) {
  return documentRecord && documentRecord.in ? documentRecord.in : documentRecord;
}

function refresh(options) {
  return options && typeof options.submitCallback === 'function' ? options.submitCallback() : null;
}

function downloadDocument(documentRecord) {
  var record = normalizeDocumentRecord(documentRecord);
  if (!record || !record.filename) return;
  var param = encodeURIComponent(record.filename);
  window.open(`/api/v1/getDocument?filename=${param}`, '_blank');
}

function editDocument(documentRecord, options) {
  var record = normalizeDocumentRecord(documentRecord);
  if (!record) return;
  documentMetadata.editDialogue(Object.assign({}, record, {
    customModalTitle: 'Modify Document'
  }), {
    submitCallback: refresh.bind(null, options)
  });
}

function deleteDocument(documentRecord, options) {
  var record = normalizeDocumentRecord(documentRecord);
  if (!record) return;
  documentMetadata.deleteDialogue(Object.assign({}, record, {
    customDeleteTitle: 'Delete ' + (record.name || 'document') + '?'
  }), {
    dashboardCallback: refresh.bind(null, options)
  });
}

function renderActions(documentRecord, options) {
  var items = [
    {
      label: 'Download Document',
      icon: 'ion-ios-cloud-download',
      onclick: function () {
        downloadDocument(documentRecord);
      }
    }
  ];

  if (session.user().isSuperuser) {
    items.push(
      {
        label: 'Edit Document',
        icon: 'ion-ios-compose',
        onclick: function () {
          editDocument(documentRecord, options);
        }
      },
      {
        label: 'Delete Document',
        icon: 'ion-ios-trash',
        class: 'red',
        onclick: function () {
          deleteDocument(documentRecord, options);
        }
      }
    );
  }

  return m(rowActionDropdown, {
    align: 'right',
    items: items
  });
}

module.exports = {
  renderActions: renderActions,
  editDocument: editDocument,
  deleteDocument: deleteDocument
};
